import type { GossipItem } from "@/mocks/gossip";

interface Props {
  lead: GossipItem;
  onRead: (item: GossipItem) => void;
}

export default function Hero({ lead, onRead }: Props) {
  return (
    <section id="top" className="relative overflow-hidden">
      <div className="absolute inset-x-0 top-0 h-72 bg-gradient-to-b from-primary-100/80 to-transparent" aria-hidden="true"></div>

      <div className="relative mx-auto max-w-[1440px] px-4 pb-10 pt-8 md:px-8 md:pt-12">
        <div className="grid grid-cols-1 items-center gap-10 lg:grid-cols-12">
          <div className="lg:col-span-6">
            <p className="inline-flex items-center gap-2 rounded-full bg-accent-100 px-4 py-1.5 text-xs font-medium text-accent-800">
              <span className="inline-block h-1.5 w-1.5 animate-pulse rounded-full bg-accent-500" aria-hidden="true"></span>
              今日瓜棚已开张 · 新料持续上架
            </p>
            <h1 className="mt-6 text-4xl leading-tight text-foreground-950 md:text-5xl">
              一口一个，把
              <span className="mx-1 inline-block -rotate-2 bg-primary-500 px-2 text-background-50">娱乐圈大瓜</span>
              全啃明白
            </h1>
            <p className="mt-5 max-w-xl text-base leading-relaxed text-foreground-600 md:text-lg">
              娱乐八卦、明星绯闻、圈内爆料、吃瓜现场——爆料网把散落在各处的热料串成一个瓜田。今日份新鲜大瓜、独家线索、红毯名场面，点开就能刷，不怕没瓜吃。
            </p>

            <div className="mt-7 flex flex-wrap items-center gap-3">
              <a
                href="#hot"
                className="inline-flex whitespace-nowrap items-center gap-2 rounded-full bg-primary-500 px-6 py-3 text-sm font-semibold text-background-50 transition-transform hover:-translate-y-0.5 hover:bg-primary-600"
              >
                开逛今日瓜田
                <i className="ri-arrow-right-line text-base leading-none" aria-hidden="true"></i>
              </a>
              <a
                href="#rank"
                className="inline-flex whitespace-nowrap items-center gap-2 rounded-full border border-background-300 bg-background-50 px-6 py-3 text-sm font-semibold text-foreground-800 transition-colors hover:border-primary-300 hover:text-primary-700"
              >
                <i className="ri-fire-fill text-base text-primary-500" aria-hidden="true"></i>
                看瓜摊热榜
              </a>
            </div>

            <dl className="mt-9 grid grid-cols-3 gap-4 max-w-md">
              {[
                { n: "5000+", t: "累计上架热料" },
                { n: "24小时", t: "滚动更新不断档" },
                { n: "120w+", t: "爱吃瓜的瓜友" },
              ].map((s) => (
                <div key={s.t} className="rounded-2xl bg-background-100/80 px-4 py-3">
                  <dt className="sr-only">{s.t}</dt>
                  <dd className="font-display-head text-2xl text-primary-600">{s.n}</dd>
                  <dd className="mt-1 text-xs text-foreground-600">{s.t}</dd>
                </div>
              ))}
            </dl>
          </div>

          <div className="lg:col-span-6">
            <div className="relative">
              <div className="absolute -inset-3 -rotate-1 rounded-[2rem] bg-accent-200/60" aria-hidden="true"></div>
              <div className="relative overflow-hidden rounded-[2rem] bg-background-100 shadow-none">
                <img
                  src="https://readdy.ai/api/search-image?query=stylish%20red%20carpet%20party%20scene%20with%20bokeh%20lights%20and%20celebrity%20silhouettes%20under%20spotlights%2C%20confetti%20in%20the%20air%2C%20festive%20magazine%20cover%20style%2C%20warm%20golden%20and%20coral%20tones%2C%20editorial%20photography&width=880&height=600&seq=hero-gossip-cover&orientation=landscape"
                  alt="娱乐圈红毯现场与星光灯影，寓意最新明星大瓜资讯"
                  className="h-64 w-full object-cover object-top md:h-[420px]"
                />
                <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-foreground-950/80 to-transparent p-5 pt-14">
                  <span className="inline-block rounded-full bg-secondary-500 px-3 py-1 text-[11px] font-medium text-background-50">
                    今日头条 · {lead.category}
                  </span>
                  <button
                    type="button"
                    onClick={() => onRead(lead)}
                    className="mt-3 block text-left text-lg font-semibold leading-snug text-background-50 transition-colors hover:text-accent-200 md:text-xl"
                  >
                    {lead.title}
                  </button>
                </div>
              </div>

              <button
                type="button"
                onClick={() => onRead(lead)}
                className="absolute -bottom-5 -left-4 inline-flex items-center gap-2 rounded-full bg-foreground-950 px-5 py-3 text-sm font-semibold text-background-50 transition-transform hover:-translate-y-1 md:-left-6"
                aria-label="展开头条详情"
              >
                <i className="ri-arrow-down-circle-fill text-lg leading-none text-accent-400" aria-hidden="true"></i>
                展开吃这个瓜
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}